import API from "../services/api";
import { PushNotifications } from '@capacitor/push-notifications' 
const attribute = "fcm";
const Service = {
    saveToken: id => {
        return new Promise((resolve, reject) => {
        
            PushNotifications.requestPermissions().then( result => {
                if (result.receive === 'granted') {
                //if (result.granted) {
                  // Register with Apple / Google to receive push via APNS/FCM
                  PushNotifications.register();
                } else {
                  // Show some error
                }
              })
              .catch(ex=>{
                  console.log('Request permission failed',ex)
              });
           
    
            // On succcess, we should be able to receive notifications
            PushNotifications.addListener('registration',
                (token) => {
                    console.log('Push registration success, token: ' , token);
                    API.post(attribute + "/" + token.value, null, null).then(
                        result => {
                            console.log('Token send to user');
                            resolve(result);
                        },
                        error => {
                            console.log('Token NOT send to user', error);
                            reject(error);
                        }
                    );
                }
            );
    
            // Some issue with our setup and push will not work
            PushNotifications.addListener('registrationError',
                (error) => {
                    console.log('Error on registration: ' + JSON.stringify(error));
                }
            );


            


            

        /*
               
                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();

                // On succcess, we should be able to receive notifications
                PushNotifications.addListener('registration',
                    (token) => {
                        console.log('Push registration success, token: ', token.value);
                        API.post(attribute + "/" + token.value, null, null).then(
                            result => {
                                console.log('Token send to user');
                                resolve(result);
                            },
                            error => {
                                console.log('Token NOT send to user', error);
                                reject(error);
                            }
                        );
                    }
                );

                // Some issue with our setup and push will not work
                PushNotifications.addListener('registrationError',
                    (error) => {
                        console.log('Error on registration: ' + JSON.stringify(error));
                    }
                );
         

          
                    if(window.FirebasePlugin){
                        window.FirebasePlugin.grantPermission();
                        window.FirebasePlugin.getToken(function(token) {
                            console.log('token ' + token);
                            API.post(attribute + "/" + token,null,null).then(
                                result => {
                                  resolve(result);
                                },
                                error => {
                                    reject(error);
                                }
                              );
                           
                        }, function(error) {
                            console.error(error);
                        });
                    }
                    */
        });
    }
}
export default Service;